export enum ChecklistStatus {
    NotStarted = 0,
    Pending = 1,
    Pass = 2,
    Fail = 3,
}
